import { useQuery } from '@tanstack/react-query';
import { AnalyticsIndex, FranchiseCaseStudy } from '../types/analytics';

const fetchAnalyticsIndex = async (): Promise<AnalyticsIndex> => {
  const response = await fetch('/data/analytics/index.json');
  if (!response.ok) {
    throw new Error('Failed to fetch analytics index');
  }
  return response.json();
};

const fetchCaseStudy = async (path: string): Promise<FranchiseCaseStudy> => {
  const response = await fetch(path);
  if (!response.ok) {
    throw new Error('Failed to fetch analytics case study');
  }
  return response.json();
};

export const useAnalyticsIndex = () => useQuery({
  queryKey: ['analytics'],
  queryFn: fetchAnalyticsIndex,
  staleTime: 1000 * 60 * 30,
  retry: 1,
});

export const useAnalyticsCaseStudy = (path?: string) => useQuery({
  queryKey: ['analytics', 'case-study', path],
  queryFn: () => fetchCaseStudy(path!),
  enabled: !!path,
  staleTime: 1000 * 60 * 30,
  retry: 1,
});
